import {useTheme} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router-dom';

import {IconIllustration} from 'presentation/components';
import {ProfileEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {MyProfileEnum} from 'main/analytics/gaTagsEnum';
import {
	StyledCard,
	StyledCardActions,
	StyledIconButton,
	StyledListItem,
	StyledListItemText,
	StyledStackContent,
	StyledStackWrapper,
} from './styles';

const {changePassword} = translations['pt-br'].privateFlow.profile;

export function ChangePasswordField() {
	const {palette} = useTheme();
	const navigate = useNavigate();

	const handleNavToChangePassword = () => {
		navigate(ProfileEnum.CHANGE_PASSWORD);
	};

	return (
		<StyledCard
			elevation={0}
			onClick={handleNavToChangePassword}
			data-tag-id={MyProfileEnum.CLICK_ALTERAR_SENHA}>
			<StyledCardActions>
				<StyledStackWrapper>
					<StyledListItem
						disablePadding
						secondaryAction={
							<StyledIconButton>
								<Icon
									name="arrow-right-filled"
									size={20}
									color={palette.primary.main}
								/>
							</StyledIconButton>
						}>
						<StyledStackContent>
							<IconIllustration
								variant="primary"
								customIconName="closed-padlock"
								size="smaller"
							/>
							<StyledListItemText
								primary={changePassword.title}
								primaryTypographyProps={{
									variant: 'body2',
								}}
							/>
						</StyledStackContent>
					</StyledListItem>
				</StyledStackWrapper>
			</StyledCardActions>
		</StyledCard>
	);
}
